import { replaceCurrentSearchParams } from '@intelligence/v3/utils/urlSearchParams';

export const ROBLOX_GAME_RANK_PATH = '/intelligence/casualGamesHub/robloxGameRank';
export const ROBLOX_TOP_CHARTS_PATH = '/intelligence/casualGamesHub/robloxTopCharts';
export const ROBLOX_DRILL_DOWN_GAME_ID_QUERY_KEY = 'game_id';
export const ROBLOX_DRILL_DOWN_GAME_NAME_QUERY_KEY = 'game_name';

export const getRobloxTopChartsDrillDownHref = (
  gameId: string,
  gameName?: string,
): string => {
  if (!gameId) {
    return ROBLOX_TOP_CHARTS_PATH;
  }

  const searchParams = new URLSearchParams({
    [ROBLOX_DRILL_DOWN_GAME_ID_QUERY_KEY]: gameId,
  });

  if (gameName) {
    searchParams.set(ROBLOX_DRILL_DOWN_GAME_NAME_QUERY_KEY, gameName);
  }

  return `${ROBLOX_TOP_CHARTS_PATH}?${searchParams.toString()}`;
};

export const parseRobloxTopChartsDrillDownGameId = (
  search?: string,
  query?: Record<string, unknown>,
): string => {
  const queryGameId = query?.[ROBLOX_DRILL_DOWN_GAME_ID_QUERY_KEY];

  if (queryGameId !== undefined && queryGameId !== null && String(queryGameId)) {
    return String(queryGameId);
  }

  if (!search) {
    return '';
  }

  const searchParams = new URLSearchParams(
    search.startsWith('?') ? search.slice(1) : search,
  );

  return searchParams.get(ROBLOX_DRILL_DOWN_GAME_ID_QUERY_KEY) || '';
};

export const parseRobloxTopChartsDrillDownGameName = (
  search?: string,
  query?: Record<string, unknown>,
): string => {
  const queryGameName = query?.[ROBLOX_DRILL_DOWN_GAME_NAME_QUERY_KEY];

  if (queryGameName !== undefined && queryGameName !== null && String(queryGameName)) {
    return decodeURIComponent(String(queryGameName));
  }

  if (!search) {
    return '';
  }

  const searchParams = new URLSearchParams(
    search.startsWith('?') ? search.slice(1) : search,
  );
  const gameName = searchParams.get(ROBLOX_DRILL_DOWN_GAME_NAME_QUERY_KEY);

  return gameName ? decodeURIComponent(gameName) : '';
};

export const clearRobloxTopChartsDrillDownGameIdFromUrl = (): void => {
  replaceCurrentSearchParams(
    {},
    [ROBLOX_DRILL_DOWN_GAME_ID_QUERY_KEY, ROBLOX_DRILL_DOWN_GAME_NAME_QUERY_KEY],
  );
};
